import { render, staticRenderFns } from "./QuestionExerciseAdd.vue?vue&type=template&id=5a2e06b3&scoped=true&"
import script from "./QuestionExerciseAdd.vue?vue&type=script&lang=js&"
export * from "./QuestionExerciseAdd.vue?vue&type=script&lang=js&"
import style0 from "./QuestionExerciseAdd.vue?vue&type=style&index=0&id=5a2e06b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2e06b3",
  null
  
)

export default component.exports